export const device = {
  mobile: `(max-width: 425px)`,
};
